export const colors = {
  custom_blue: "#2bb7e5",
  custom_red: "#E90303",
  custom_primary: "#FF6652",
  custom_red_70: "rgba(233, 3, 3, 0.7)",
  custom_yellow: "#FFBD06",
  custom_darkgray: "#3D3D3D",
  custom_gray: "#E8E8E8",
  custom_lightgray: "#F9F6F6",
  custom_green: "#3BBE50",
  facebook: "#3237C0",
  google: "#E90303",
};
